import { useState } from 'react';

const useAsyncFunction = (func: Function) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null as unknown);
    const [result, setResult] = useState(null);

    const execute = async (...args: any[]) => {
        setLoading(true);
        setError(null);
        try {
            const result = await func(...args);
            setResult(result);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    };

    return { execute, loading, error, result };
};

export default useAsyncFunction;
